import React from "react";
import { Layout } from "../components/Layout";
import { GamePostContent } from "../components/content/GamePostContent";
import { PostSidebar } from "../components/sidebars/PostSidebar";
import { GamePageContent } from "../components/GamePageContent";
import { BlogPostContent } from "../components/BlogPostContent";
import { GET_BASE_INDEX } from "../mysql/queries/index-page";
import { GET_POSTS_PATHS, GET_POST_BY_URI } from "../mysql/queries/posts";
import { Meta } from "../components/Meta";
import { removeTags } from "../util/removeTags";
import { getPosts } from "../util/Post";

// this is used in static generation to get a list of all the possible game paths
export const getStaticPaths = async () => {
  const pathResult = await GET_POSTS_PATHS();
  const paths = pathResult.map(path => `/${path.slug}`);
  getPosts().map((filePost) => {
    paths.push(filePost.slug)
  });

  return {
    paths,
    fallback: false,
  };
};

export const getStaticProps = async ({ params }) => {
  let post = null;
  let relatedPosts = [];
  try {
    post = await GET_POST_BY_URI(params.slug);
  } catch (ex) {
    console.error(`failed to get post from DB by slug ${params.slug}`, ex);
  }

  if (!post) { // check for files
    const filePosts = getPosts().map((post) => ({
      ...post,
      post_date: post.date,
      uri: post.slug,
      post_content: post.contentHTML,
      categories: [
        {
          "uri": "/category/blog/",
          "name": "Blog"
        }]
    }));

    filePosts.forEach((filePost) => {
      if (filePost.slug === "/" + params.slug)
        post = filePost;
    });
  }

  if (!post) {
    throw new Error(`Could not find post ${params.slug}`);
  }

  let indexResult = {};
  try {
    indexResult = await GET_BASE_INDEX();
  } catch (ex) {
    console.error("failed to execute index query", ex);
  }

  return {
    props: {
      data: {
        postBy: post,
        ...indexResult,
        relatedPosts,
      },
    },
  };
};

const Pages = ({ data }) => {
  const isBlog = data.postBy.categories.filter(cat => cat.name === 'Blog').length > 0 ? true : false;

  const title = data.postBy.seo_title
    ? data.postBy.seo_title + " | Radcade"
    : data.postBy.title + " | Radcade";

  let description = data.postBy.seo_description ?
    data.postBy.seo_description :
    data.postBy.meta && data.postBy.meta.description ?
      data.postBy.meta.description :
      removeTags(data.postBy.post_content).substring(0, 160).replace(/(\r\n|\n|\r|\t)/gm, " ");
  const url = `${data.postBy?.uri}`;

  const image_url = data.postBy.featured_image_url ? data.postBy.featured_image_url :
    data.postBy.mabp_screen1_url ? data.postBy.mabp_screen1_url :
      data.postBy.images ? data.postBy?.images[0]?.sourceUrl :
        `/ wp - content / uploads / 2020 / 06 / cropped - radcade11cleaning.png`;

  return (
    <Layout data={data}>
      <Meta
        title={title}
        description={description}
        url={url}
        image_url={image_url}
        type="entry" />
      {!isBlog && <GamePageContent data={data} />}
      <div className="responsive flex-col md:flex-row">
        <div className="flex-grow">
          {!isBlog ? (
            <GamePostContent data={data} />
          ) : (
            <BlogPostContent data={data} />
          )}
        </div>
        <div className="w-sidebar flex-shrink-0 md:ml-5">
          <PostSidebar data={data} />
        </div>
      </div>
    </Layout>
  );
};

export default Pages;
